import Button from "../../../../components/Button/Button";
import Checkbox from "../../../../components/Checkbox/Checkbox";
import { WorkflowReportSettings } from "../../../../types/types";
import { ReportControlsProps } from "./ReportControls.types";

const ReportControls = (props: ReportControlsProps) => {

  const {
    showTHzGraphsCheckbox,
    showScanImagesCheckbox,
    showTHzHeatmapCheckbox,
    isDownloadingReport,
    onGenerateReport
  } = props

  const generateReport = () => {
    const settings: WorkflowReportSettings = {
      include_heatmap_thz: showTHzHeatmapCheckbox.value,
      include_graph_thz: showTHzGraphsCheckbox.value,
      include_images: showScanImagesCheckbox.value
    }
    onGenerateReport(settings)
  }

  return (
    <>  
      <h2 className="analysis-control-title">Analysis</h2>

      <Checkbox 
        label="Include THz heatmap"
        checkbox={showTHzHeatmapCheckbox}
        isLoading={false}
      />

      <Checkbox 
        label="Include THz graphs"
        checkbox={showTHzGraphsCheckbox}
        isLoading={false}
      />

      <Checkbox 
        label="Include scan images"
        checkbox={showScanImagesCheckbox}
        isLoading={false}
      />

      <Button
        title="Download Report"
        onClick={generateReport}
        type="full"
        disabled={isDownloadingReport}
        isLoading={isDownloadingReport}
      />
    </>
  )
}

export default ReportControls